<template>
	<main id="container" class="page-container">
		<div class="page-header">
			<div class="container">
				<div class="display-flex is-between">
					<page-header title="이벤트" />
				</div>
			</div>
		</div>
		<div class="page-content event-check event-dineOut">
			<div class="container">
				<div class="page-sub-header">
					<h3 class="page-sub-title"><span class="prima">동행축제 이벤트에 참여하고</span> 푸짐한 선물 받으세요.</h3>
				</div>
			</div>
			<div class="page-tab-container">
				<div class="container tab-buttons">
					<!-- <router-link to="eatingOut" class="tab-button">외식 활성화</router-link> -->
					<!-- <router-link to="dineOut" class="tab-button is-active">오늘 식사 한 끼, 밖에서 먹어요</router-link> -->
					<!-- <router-link to="check" class="tab-button">출석체크</router-link>
					<router-link to="ranking" class="tab-button">랭킹게임</router-link>
					<router-link to="dibs" class="tab-button">찜하기</router-link>
					<router-link to="sns" class="tab-button">구매후기</router-link>
					<router-link to="delivery" class="tab-button">공공배달앱 이용후기</router-link>
					<router-link to="challenge" class="tab-button">동행 숨결 챌린지</router-link> -->
				</div>
			</div>
			<div class="container">
				<div class="event-check-container">
					<div class="event-check-header">
						<div class="event-check-header-img">
							<div class="banner-img">
								<img src="@/assets/img/event/event2025_0318_2.jpg" alt="EVENT 02 오늘 식사 한 끼, 밖에서 먹어요 이벤트" />
							</div>
						</div>
						<div class="event-check-header-info">
							<ul class="event-check-header-info-list">
								<li v-for="(item, idx) in infoList" :key="idx">
									<span class="infolist-title">{{ item.title }}</span>
									<span class="infolist-text">{{ item.detail }}</span>
								</li> 
								<li style="display: flex; align-items: flex-start; list-style: none; ">
									<span class="infolist-title ">{{ '진행방식' }}</span>
									<!-- 줄 바꿈을 해야하기 때문에 바인딩 하지않고 하드코딩으로 변경 -->
									<span class="infolist-text">전통시장, 동네상권 소상공인 자영업자 운영 식당 이용 후, 네이버폼 통해 영수증 인증 접수
										<br>
										<br>골목상권 및 전통시장 확인처 : 전통시장통통 온누리상품권 가맹점포찾기
										<br><a href="https://www.sbiz.or.kr/sijangtong/nation/onnuri/onnuriMktList.do?menu_id=070400" target="_blank">https://www.sbiz.or.kr/sijangtong/nation/onnuri/onnuriMktList.do?menu_id=070400</a>
										<br>
										<br>백년가게 확인처 : 백년가게/소공인 홈페이지
										<br><a href="https://www.sbiz.or.kr/hdst/main/ohndMarketList.do" target="_blank">https://www.sbiz.or.kr/hdst/main/ohndMarketList.do</a>
									</span>
								</li>
							</ul>
						</div>
					</div>
					<div class="event-check-guide">
						<span class="event-check-guide-title">참여방법</span>
						<div class="event-check-guide-desc no-border">
							<ul class="event-check-guide-desclist">
								<li class="event-check-guide-desclist-li">
									<div class="event-check-guide-desclist-img hidden-mobile">
										<img src="@/assets/img/event/dineOut_0318_1.png" alt="" />
									</div>
									<div class="event-check-guide-desclist-text">
										<span class="desclist-title">STEP 1</span>
										<span class="desclist-text">전통시장, 동네상권 소상공인 자영업자 운영 식당에서 식사 또는 포장 주문</span>
									</div>
								</li>
								<li class="event-check-guide-desclist-li">
									<div class="event-check-guide-desclist-img hidden-mobile">
										<img src="@/assets/img/event/dineOut_0318_2.png" alt="" />
									</div>
									<div class="event-check-guide-desclist-text">
										<span class="desclist-title">STEP 2</span>
										<span class="desclist-text">네이버폼에 식당영수증 사진과 필수 기재사항을 접수하면 응모가 완료 됩니다.</span>
										<div class="desclist-tag">
											<span class="tag-title">네이버폼</span>
											<div class="tag-item">
												<span>https://naver.me/59vrLIbU</span><span class="accept-button"><a href="https://naver.me/59vrLIbU" target="_blank">접수하기</a></span>
											</div>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
					<div class="event-check-products">
						<span class="event-check-products-title">경품소개</span>
						<table class="my-table">
							<tbody>
							<tr>
								<th rowspan="4"><img :src="require(`@/assets/img/main/item_dine_out.jpg`)" /></th>
								<td><span>1등</span>  50만원권 (5명)</td>
							</tr>
							<tr>
								<td><span>2등</span> 5만원권 (30명)</td>
							</tr>
							<tr>
								<td><span>3등</span>  1만원권 (100명)</td>
							</tr>
							</tbody>
						</table>
						<!-- <ul class="event-check-products-list">
							<li class="event-check-products-list-li" v-for="(item, idx) in prdList" :key="idx">
								<div class="event-check-products-item">
									<div class="event-check-products-item-img">
										<img :src="require(`@/assets/img/main/${item.img}`)" :alt="item.title" />
									</div>
									<div class="event-check-products-item-title">
										<span class="item-title-wrap">
											<span class="item-title">{{ item.title }}</span>
											<span class="item-title boldtxt">{{ item.person }}</span>
										</span>
									</div>
								</div>
							</li>
						</ul> -->
					</div>
				</div>
			</div>
			<div class="event-check-button-box">
				<div class="container flex-column">
					<span class="event-check-prect-title">경품발송</span>
					<ul class="event-check-prect-list">
						<li class="event-check-prect-list-li" v-for="(item, idx) in deliveryList" :key="idx">
							<span class="prect-list-text" v-html="item"></span>
						</li>
					</ul>
					
				</div>
			</div>

			<div class="into-area">
				<button type="button" v-if="isShowBtn" class="event-check-button" @click="clickLink('https://naver.me/59vrLIbU')">참여하기</button>
				<!-- <span class="into-button"><a href="https://naver.me/5bV9JGrN" target="_blank">참여하기</a></span> -->
			</div>

			<div class="event-check-prect">
				<div class="container">
					<span class="event-check-prect-title">유의사항</span>
					<ul class="event-check-prect-list">
						<li class="event-check-prect-list-li" v-for="(item, idx) in prectList" :key="idx">
							<div class="prect-list-text" v-html="item"></div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</main>
</template>

<style scoped>
.accept-button a{
	width: 80px; /* 버튼 너비 유지 */
  	height: 25px;  /* 버튼 높이 유지 */
	  border-radius: 7px;
	display: inline-flex;
    background-color: #e7dc37;    
    color: #000000;
    font-size: 17px;
    font-weight: 400;    
    justify-content: center;
    align-items: center;	
}
.into-area{
	text-align: center;
}
.into-button a{
	display: inline-flex;
    padding: 6px 12px;
    background-color: #f5e50e;
    border-radius: 16px;
    color: #ffffff;
    font-size: 25px;
    font-weight: 700;
    white-space: nowrap;
    justify-content: center;
    align-items: center;
	margin-top: 50px;	
}


.my-table {
  border-collapse: collapse; /* 셀 간 간격 제거 */
  width: 100%; /* 테이블 너비 설정 (선택 사항) */
  overflow: hidden; /* border-radius가 잘리는 것 방지 */
  margin-top: 30px;
  width: 52%; /* 표 너비 설정 */  
}

.my-table th,
.my-table td {
  border: 1px solid #ebebeb; /* 테두리 추가 */
  padding: 8px; /* 셀 안쪽 여백 */
  text-align: center; /* 텍스트 가운데 정렬 */
  width: 200px;
}

.my-table th {
  background-color: #ffffff; /* 제목 셀 배경색 */
}
.my-table span{
	font-weight: bold;
}

.prect-list-text {
  display: block;
  width: calc(100% - 30px);
}
.prect-list-text a {
  word-break: break-all; /* Break words at any character */
  overflow-wrap: break-word; /* Allow long words to be broken */
  display: inline;
}
.prect-list-text ::v-deep a.appstore-link {
  font-size: 19px; /* 원하는 폰트 사이즈로 조절 */
  color: red;
}
.prect-list-text ::v-deep .info-color {
  color: red;
}

</style>

<script>
import PageHeader from '@/components/content/PageHeader';
export default {
	name: 'EventDineOut',
	components: { PageHeader },
	data: () => ({
		visibleModal: false,
		infoList: [
			{
				title: '참여기간',
				detail: '2025년 3월 13일(목) ~ 2025년 4월 12일(토)',
			},
			{
				title: '결과발표',
				detail: '2025년 4월 중',
			},
			{
				title: '경품발송',
				detail: '2025년 5월 중',
			},
		],
		prdList: [
			{
				img: 'item_eating_1.jpg',
				title: '온누리상품권 1만원',
				person: '(100명)',
			},
			{
				img: 'item_eating_1.jpg',
				title: '온누리상품권 5만원',
				person: '(40명)',
			},
			{
				img: 'item_eating_1.jpg',
				title: '온누리상품권 10만원',
				person: '(10명)',
			},
			{
				img: 'item_eating_1.jpg',
				title: '온누리상품권 50만원',
				person: '(2명)',
			},
		],
		deliveryList: ['이벤트 미션 완료자 대상으로 추첨을 통해 당첨자 선정', '5만원 이하 경품 : 네이버폼 접수 시 기재한 번호로 디지털온누리앱에서 선물하기 경품 전송' , '5만원 초과 경품 : 개별 연락 후 제세공과금(22%) 납부 안내 및 개인정보 및 고유식별정보 수집·이용 및 제공 동의 → 제세공과금 납부 확인 후 네이버폼 접수 시 기재한 번호로 디지털온누리앱에서 선물하기 경품 전송'],

		prectList: [
		'본 이벤트는 전통시장, 동네상권 소상공인 자영업자 운영 식당 이용 후, 홈페이지 이벤트 안내 페이지 내 [오늘 식사 한 끼, 밖에서 먹어요 이벤트 참여] 버튼을 클릭하여 네이버폼에 접수해 주시면 응모가 완료됩니다.',
		'<div class="info-color">디지털 온누리상품권으로 지급예정으로 디지털온누리앱에 가입한 자에게 선물하기를 통해 경품 지급 가능합니다. <br>* 구글플레이스토어 : <a href="https://play.google.com/store/apps/details?id=com.komsco.kpay" target="_blank" class="appstore-link">https://play.google.com/store/apps/details?id=com.komsco.kpay</a> <br>* 앱스토어 : <a href="https://apps.apple.com/kr/app/%EB%94%94%EC%A7%80%ED%84%B8%EC%98%A8%EB%88%84%EB%A6%AC/id6738372450" target="_blank" class="appstore-link">https://apps.apple.com/kr/app/%EB%94%94%EC%A7%80%ED%84%B8%EC%98%A8%EB%88%84%EB%A6%AC/id6738372450</a></div>',
    	'<div class="info-color">이름과 휴대폰 번호가 디지털온누리앱의 가입 정보와 일치한 경우에만 선물을 받을 수 있습니다.</div>',
		'이벤트 참여 응모를 위한 네이버폼으로 취합 된 개인정보는 이벤트 경품 발송 절차가 모두 완료된 이후에 즉시 폐기 됩니다.',
		'지급 된 쿠폰 사용 시, 발송된 쿠폰 내 유의사항을 반드시 확인 바랍니다.',
		'당첨 쿠폰이 분실, 도난 된 경우, 재발송이 불가합니다. (당첨 쿠폰 복사 및 저장 필수)',
		'5만원 초과 경품 당첨의 경우 제세공과금(22%)는 본인이 부담해야 합니다.',
		'당첨자는 이벤트 종료 후 1개월 이내 공지될 예정입니다.',
		'당첨자의 잘못된 정보 입력으로 인해 경품 누락이 될 경우 재 발송되지 않습니다.',
		'해당 이벤트에 만 14세 미만은 참여할 수 없습니다.<span class="info-color">(만 14세 미만 참여자의 경우 경품 당첨이 취소 됩니다.)</span>',
		'이벤트 일정 및 경품내역은 추후 주최 측의 사정에 따라 변동 가능합니다.',
		'이벤트에 관한 문의는 대행사인 <span style="font-weight: bold;">㈜지엠컴 070-4838-6391</span>로 문의 바라며, 상담 가능 시간은 평일 오전 10시 ~ 오후 7시입니다.'
		],
		eventStart: false,
		mergedTitle: '제품 정보',
		content: ['사과', '바나나', '딸기', '포도'],
	}),
	computed: {
		isShowBtn() {
			return new Date() < new Date("2025-04-13 00:00:00")
		}
	},
	watch: {},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				const thisTab = document.querySelector('.tab-button.is-active');
				thisTab.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}, 100);
		});
	},
	methods: {
		clickEvent(e) {
			// let url = 'https://doit5.com/kshoppingfesta/direct?gc=a15';
			let url = 'https://doit5.com/kshoppingfesta/list.php';
			const w = 560;
			const h = 600;
			const title = '이벤트';

			// 브라우저 창의 크기 가져오기
			const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
			const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

			const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
			const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

			// 팝업창의 중앙 좌표 계산
			const left = width / 2 - w / 2 + dualScreenLeft;
			const top = height / 2 - h / 2 + dualScreenTop;

			// 팝업창 설정
			const options = `
				scrollbars=yes,
				width=${w}, 
				height=${h}, 
				top=${top}, 
				left=${left},
				status=no,
				menubar=no,
				toolbar=no,
				location=no,
				directories=no,
				copyhistory=no
			`.replace(/\s+/g, '');

			// 팝업창 열기
			const newWindow = window.open(url, title, options);

			// 팝업창이 차단되었는지 확인
			if (window.focus && newWindow) {
				newWindow.focus();
			}

			return newWindow;
		},
		clickLink(url) {
			window.open(url, '_blank');
		},
	},
};
</script>
